import React, { useEffect, useState } from "react";
import { Form, Input, Button, message, Alert, Divider } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { LoginContainerSC, LoginTitleSC, StyledCardSC } from "./styles";
import { useAuth } from "../../../providers/AuthProvider";

export const Login: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const { login, isAuthenticated, loginWithSite, siteLoginError } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const fromLocation = (location.state as any)?.from;
    const from = fromLocation?.pathname || "/";
    // Вход через сайт — для редактора эфира (/fast/<медиа>): сайт возвращает только туда.
    const siteReturn = from.startsWith("/fast/")
        ? `${window.location.origin}${from}${fromLocation?.search || ""}`
        : null;

    useEffect(() => {
        console.log("isAuthenticated loginpage", isAuthenticated);
    }, [isAuthenticated]);

    const onFinish = (values: { username: string; password: string }) => {
        setLoading(true);

        // Simulate a slight delay for better UX
        setTimeout(() => {
            const success = login(values.username, values.password);

            if (success) {
                message.success("Login successful!");
                navigate(from, { replace: true });
            } else {
                message.error("Invalid username or password");
            }

            setLoading(false);
        }, 500);
    };

    return (
        <LoginContainerSC>
            <StyledCardSC>
                <LoginTitleSC level={2}>Torsunov Subtitles</LoginTitleSC>
                {siteLoginError && (
                    <Alert type="warning" showIcon style={{ marginBottom: 16 }} message={siteLoginError} />
                )}
                {siteReturn && (
                    <>
                        <Button block size="large" onClick={() => loginWithSite(siteReturn)}>
                            Войти через сайт (переводчик эфира)
                        </Button>
                        <Divider plain style={{ fontSize: 12 }}>
                            или логином редактора
                        </Divider>
                    </>
                )}
                <Form name="login" onFinish={onFinish} autoComplete="off" size="large">
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: "Please input your username!" }]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Username" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: "Please input your password!" }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Password" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading} block>
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </StyledCardSC>
        </LoginContainerSC>
    );
};
